import Badge from '@components/atoms/Badge'
import type { IconTypes } from '@components/utils/Icon'
import { ImportStatus } from '@utils/imports/import'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('imports.statuses')

type Appearance = { color: 'gray' | 'info' | 'success' | 'warning' | 'error'; icon: IconTypes }

const APPEARANCE: Record<ImportStatus, Appearance> = {
  [ImportStatus.Queued]: { color: 'gray', icon: 'clock' },
  [ImportStatus.Working]: { color: 'info', icon: 'refresh' },
  [ImportStatus.Completed]: { color: 'success', icon: 'check-circle' },
  [ImportStatus.CompletedWithFailures]: { color: 'warning', icon: 'alert-triangle' },
  [ImportStatus.Failed]: { color: 'error', icon: 'x-circle' },
}

export function ImportStatusBadge({ status }: { status: ImportStatus }) {
  const { color, icon } = APPEARANCE[status]

  return (
    <Badge color={color} shape="rounded" leadingIcon={icon}>
      {t(status)}
    </Badge>
  )
}
